import React, { useState, useEffect } from "react";
import Sidebar from "../../Sidebar";
import Header from "../../Header";
import swal from "sweetalert";
import { API } from "../../../../API";
import axios from "axios";
import { useHistory } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
// import ReactDatePicker from "react-datepicker";
import DatePicker from "react-datepicker";
import { Link } from "react-router-dom";
import Footer from "../../Footer";
import { isAutheticated } from "../../../auth/authhelper";

export default function Addsubject() {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(new FormData());
  const [data, setData] = useState({
    title: "",              // For title input
    banner: null,           // Updated for file handling (use null for a file initially)
    category: "",           // For category selection
    startDate: new Date(),  // For start date
    endDate: new Date(),    // For end date
  });

  const wordLimit = {
    title: 50,
  };
  const [titleLen, setTitleLen] = useState(wordLimit.title);
  console.log(data)
  const { token } = isAutheticated();
  const history = useHistory();
  const onSubmit = (e) => {
    if (data.title === "" || data.banner === "" || data.category === "") {
      alert("Please fill all property which is mendatory");
      return;
    }
    e.preventDefault();
    // Set all form data fields
    // formData.set("title", data.title);
    // formData.set("category", data.category);
    // formData.set("startdate", data.startDate.toISOString());
    // formData.set("enddate", data.endDate.toISOString());
    // formData.set("file", data.banner);

    setLoading(true);
    axios
      .post(`${API}/api/banner/addbanner`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/formdata",
        },
      })
      .then((response) => {
        console.log(response?.data);
        setLoading(false);
        // console.log(response);
        swal({
          title: "Banner added Successfully!",

          icon: "success",
          buttons: true,
          successMode: true,
          dangerMode: false,
        }).then((value) => {
          history.push("/subjects");
        });
      })
      .catch((err) => {
        setLoading(false);
        let message = err.response.data.message;
        swal({
          title: "Error",
          text: { message },
          icon: "error",
          buttons: true,
          dangerMode: true,
        });
        console.log(message);
        history.push("/subjects");
      });
  };

  const handleChange = (e) => {
    formData.set("startdate", data.startDate.toISOString());
    formData.set("enddate", data.endDate.toISOString());
    const { name, value } = e.target;
    if (name == "file") {
      formData.set(name, e.target.files[0]);
      setData({ ...data, banner: URL.createObjectURL(e.target.files[0]) });
    } else {
      setData({ ...data, [name]: value });
      formData.set(name, value);
    }
  };





  const handleEdit = (e, type) => {
    const length = e.target.value.length;
    switch (type) {
      case "title":
        if (wordLimit.title - length !== -1) {
          handleChange(e);
          setTitleLen(wordLimit.title - length);
        }
        break;
      default:
        console.log("Incorrect Type");
    }
  };

  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          {/* <!-- start page title --> */}

          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-0">Content Management - Banners</h4>

                <div className="page-title-right">
                  <ol className="breadcrumb m-0">
                    <li className="breadcrumb-item">
                      <a href="javascript: void(0);">SoComOTT</a>
                    </li>
                    <li className="breadcrumb-item">
                      Content Management - Banners
                    </li>

                    <li className="breadcrumb-item">Add New Banner</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- end page title --> */}

          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12 col-lg-6 col-xl-6">
                      <h1 className="text-left head-small">Add New Banner </h1>

                      <form>
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="form-group">
                              <label
                                for="basicpill-phoneno-input"
                                className="label-100"
                              >
                                Enter Title Name<span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control input-field"
                                id="basicpill-phoneno-input"
                                name="title"
                                value={data.title}
                                onChange={(e) => handleEdit(e, "title")}
                              />
                              <p className="pt-1 pl-2 text-secondary">
                                Remaining words : {titleLen}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-12">
                            <div className="form-group">
                              <label
                                for="basicpill-phoneno-input"
                                className="label-100"
                              >
                                Upload Banner Image(1260x500 px)<span className="text-danger">*</span>
                              </label>
                              <input
                                type="file"
                                className="form-control input-field"
                                id="basicpill-phoneno-input"
                                name="file"
                                onChange={handleChange}
                              />
                              <img
                                classNameName="img-fluid mt-2"
                                style={{
                                  height: "125px",
                                  width: "274px",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                }}
                                alt="200x200"
                                src={
                                  data.banner
                                    ? data.banner
                                    : "/bannerDefault.png"
                                }
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-12">
                            <div className="form-group">
                              <label
                                htmlFor="basicpill-phoneno-input"
                                className="label-100"
                              >
                                Select Page<span className="text-danger">*</span>
                              </label>
                              <select
                                className="form-control input-field"
                                name="category"
                                onChange={handleChange}
                              >
                                <option value="">Select</option>
                                <option value="Home">Home</option>
                                <option value="Videos">Videos</option>
                                <option value="Shop">Shop</option>
                              </select>
                            </div>
                          </div>
                        </div>


                        <div className="row">
                          <div className="col-lg-12">
                            <div className="form-group">
                              <label
                                htmlFor="basicpill-phoneno-input"
                                className="label-100"
                              >
                                Start Date<span className="text-danger">*</span>
                              </label>
                              <div className="input-group">
                                <DatePicker
                                  selected={data.startDate}
                                  required
                                  name="startdate"
                                  minDate={new Date()} // Prevent past dates
                                  onChange={(date) => {
                                    setData({
                                      ...data,
                                      startDate: date,
                                      endDate: date > data.endDate ? date : data.endDate, // Adjust endDate if needed
                                    });
                                    formData.set("startdate", date.toISOString());
                                  }}
                                  className="form-control"
                                />
                                <div className="input-group-append">
                                  <span className="input-group-text">
                                    <i
                                      className="fa fa-calendar"
                                      aria-hidden="true"
                                    ></i>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-12">
                            <div className="form-group">
                              <label
                                htmlFor="basicpill-phoneno-input"
                                className="label-100"
                              >
                                End Date<span className="text-danger">*</span>
                              </label>
                              <div className="input-group">
                                <DatePicker
                                  selected={data.endDate}
                                  required
                                  name="enddate"
                                  minDate={data.startDate || new Date()} // Prevent dates before startDate
                                  onChange={(date) => {
                                    setData({
                                      ...data,
                                      endDate: date,
                                    });
                                    formData.set("enddate", date.toISOString());
                                  }}
                                  className="form-control"
                                />
                                <div className="input-group-append">
                                  <span className="input-group-text">
                                    <i
                                      className="fa fa-calendar"
                                      aria-hidden="true"
                                    ></i>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>


                        <div className="row">
                          <div className="col-lg-12">
                            <div className="form-group text-left">
                              <Link>
                                <button
                                  type="button"
                                  className="btn btn-success btn-login waves-effect waves-light mr-3"
                                  onClick={onSubmit}
                                >
                                  <ClipLoader loading={loading} size={18} />
                                  {!loading && "Save"}
                                </button>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>

                  {/* <!-- end table-responsive --> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- container-fluid --> */}
      </div>
      {/* <!-- End Page-content --> */}

      <Footer />
    </div>
  );
}
